<template>
  <Layout>
    <template #header-container>
      <div class="container-alert" v-if="activeWizardImport == 'upload-content'">
        <McAlert
          class="custom-alert"
          variant="warning"
          :text="$t('maintenance.tooltip.importInfo')"
          withIcon
        />
      </div>
    </template>
    <PageHeader :title="title" :subTitle="subTitle">
      <template #afterTitle>
        <div class="d-flex align-items-center gap-3">
          <McButtonBack href="/maintenance/serviceschedule" />
          <McListDownloader
            :pageOptions="downloadPageOptions"
            :fileFormatOptions="['excel']"
            @download="handleDownload"
            :disabled="!importData"
            v-if="$route.name === 'Service Schedule Import Result'"
          />
        </div>
      </template>
    </PageHeader>

    <McWizard
      withNumber
      class="mc-wizard mb-4"
      :activeKey="activeWizardImport"
      :items="wizardItems"
    />

    <router-view />
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import Layout from '@/router/layouts/main'
import PageHeader from '@/components/page-header-v2'
import McButtonBack from '@/components/McButtonBack'
import McWizard from '@/components/McWizard'
import McListDownloader from '@/components/McListDownloader'
import McAlert from '@/components/McAlert'
import { mapState } from 'vuex'

export default {
  page: {
    title: 'Penjadwalan Servis',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McButtonBack,
    McWizard,
    McListDownloader,
    McAlert,
  },
  data() {
    return {
      activeWizardImport: 'upload-content',
      metadata: null,
    }
  },
  computed: {
    ...mapState('maintenance', ['importData', 'file']),
    title() {
      return this.$t('maintenance.frontPage.title.importServiceSchedule')
    },
    subTitle() {
      return this.$t('maintenance.frontPage.desc.importServiceSchedule')
    },
    wizardItems() {
      return [
        { key: 'upload-content', label: this.$t('global.action.upload') },
        { key: 'process-content', label: this.$t('global.action.process') },
        { key: 'result-content', label: this.$t('global.action.result') },
      ]
    },
    downloadPageOptions() {
      return [
        { label: 'Semua', amount: this.importData?.totalData, key: 'all' },
        { label: 'Data Gagal', amount: this.importData?.totalFailed, key: 'failed' },
        { label: 'Data Berhasil', amount: this.importData?.totalSuccess, key: 'success' },
      ]
    },
  },
  watch: {
    '$route.name': {
      handler(value) {
        this.handleActiveWizard(value)
      },
      immediate: true,
    },
  },
  methods: {
    handleActiveWizard(routeName) {
      if (routeName === 'Service Schedule Import') {
        this.activeWizardImport = 'upload-content'
        return
      }

      if (routeName === 'Service Schedule Import Detail') {
        this.activeWizardImport = 'process-content'
        return
      }

      this.activeWizardImport = 'result-content'
    },
    handleDownload(format, statusType) {
      let base64File
      if (statusType == 'all') {
        base64File = this.importData.originalFile
      } else if (statusType == 'failed') {
        base64File = this.importData.errorFile
      } else {
        base64File = this.importData.successFile
      }
      let temp = 'data:' + this.file.filetype + ';base64,' + encodeURIComponent(base64File)
      let download = document.createElement('a')
      download.href = temp
      download.download = `${statusType}_${this.file.filename}`
      document.body.appendChild(download)
      download.click()
      document.body.removeChild(download)
    },
  },
}
</script>

<style lang="scss" scoped>
:deep(.mc-wizard) {
  display: inline-block;
  width: 100%;
}

.container-alert {
  margin-top: -25px;
  margin-bottom: 20px;
}
.custom-alert {
  border: 0 !important;
  border-radius: 0;
}
.custom-alert.mc-alert.mc-alert__warning.d-flex {
  gap: 0 !important;
  padding-left: 16px !important;
}
</style>
